<template>
    <header>
        <div class="navbar_wrapper">
            <Ibar v-if="ibar" v-bind="ibar" :show-submit-button="false" :about-us="[]" />
            <div v-else class="navbar_placeholder" aria-hidden="true" />
        </div>
    </header>

    <div class="container" :class="{ 'container--tac' : isTermsAndConditions}">
        <NuxtPage />
    </div>

    <footer>
        <div class="container_footer">
            <div class="footer_left">
                <span>&copy; {{ new Date().getFullYear() }} Frontiers Media S.A. All rights reserved</span>
                <span>
                    <BLink :color-scheme="'blue'" size="sm" :inline="true" as="a" target="_blank" :to=privacyPolicyUrl>
                        Privacy Policy
                    </BLink>
                    |
                    <BLink :color-scheme="'blue'" size="sm" :inline="true" as="a" target="_blank" :to=termsAndConditionsUrl>
                        Terms and Conditions
                    </BLink>
                </span>
            </div>
            <span>Powered by <BLink :color-scheme="'blue'" size="sm" :inline="true" as="a" target="_blank" :to=loopUrl>Loop
            </BLink></span>
        </div>
    </footer>
</template>

<script setup lang="ts">
    import { NuxtPage } from "#components";
    import { BLink } from "@frontiers/brink-ui";
    import { Ibar } from "@frontiers-vue3/public-pages";
    import { storeToRefs } from "pinia";
    import { useIbarStore } from "~/stores/ibarStore";
    import { useConfigurationStore } from "~/stores/configurationStore";
    const configurationStore = useConfigurationStore();
    const configuration = configurationStore.config;

    const loopUrl = configuration?.domainProperties.loopUrl;
    const baseUrl = configuration?.domainProperties.defaultWebsite;
    const privacyPolicyUrl = baseUrl + "/legal/privacy-policy";
    const termsAndConditionsUrl = baseUrl + "/legal/terms-and-conditions";
    const ibarStore = useIbarStore();
    // Bind reactively to the store: the boot plugin (01.common-clib) already kicked off the
    // Ibar fetch in parallel with the middleware; the header fills in when it resolves. (DIF-1479)
    const { ibar } = storeToRefs(ibarStore);
    const route = useRoute();

    const isTermsAndConditions = route.path.includes("/legal/") || route.path.includes("termsandconditions");

    // Fallback kickoff (deduped) in case config wasn't ready when the boot plugin ran.
    // The layout never blocks on this — a placeholder holds the navbar height meanwhile.
    // Guarded like the boot plugin: skip when baseUrl is missing to avoid fetching `undefined/...`.
    onMounted(() => {
        if (baseUrl) {
            ibarStore.load(baseUrl);
        }
    });

</script>

<style lang="scss">
body {
  scroll-behavior: smooth;
}

#__nuxt {
  -webkit-font-smoothing: antialiased;
  justify-content: center;
  position: relative;
}

.navbar_wrapper {
  position: relative;
  left: 0;
  top: 0;
  min-height: 64px;
  /* the following style has been applied in the ibar because the shadow was missed with the scroll */
  /* box-shadow: 0 0 20px 2px lightgray; */
  z-index: 31;
}

.Ibar__wrapper {
  box-shadow: 0 0 20px 2px $grey30;
}

/* DIF-1479: holds the navbar height + shadow while the Ibar loads reactively, avoiding layout shift. */
.navbar_placeholder {
  width: 100%;
  height: 64px;
  background: #fff;
  box-shadow: 0 0 20px 2px $grey30;
}

@media screen and (max-width: 1024px) {
  .navbar_placeholder {
    height: 48px;
  }
}

@media screen and (max-width: 1024px) {
  .navbar_wrapper {
    min-height: 48px;
  }
}

.footer_left {
  display: flex;
  gap: 64px;
}

.Ibar__link,
.Ibar__burger,
.Ibar__icon--search,
.Ibar__myFrontiers {
  display: none;
}

.logo {
  display: flex;
  margin: 0;
}
</style>
